import { useClient } from '../../../../react-hooks/useClient';
import { getUserClient } from '../../../../react-hooks/useUserClient';
import {
    mapChoicesToOptions,
    sortFieldOptions,
} from '../utils/fieldOptions';

export async function fetchFieldOptions({
    modelIdentifier,
    extraFields = [],
    hiddenFields = new Set([]),
} = {}) {
    const client = useClient();
    const userClient = getUserClient();
    const instance = userClient?.getUser?.()?.instance;

    if (!client || !instance?.id) {
        return sortFieldOptions(extraFields);
    }

    try {
        const response = await client.post('form/config/editor/property', {
            contextModelId: modelIdentifier,
            contextObj: {},
        });

        const formFields = response?.data?.fields || [];
        const fieldsField = formFields.find(
            (field) => field?.property === 'property'
        );

        return mapChoicesToOptions(fieldsField?.choices || [], {
            extraFields,
            hiddenFields,
        });
    } catch (error) {
        console.error('[referenceFields] Failed to load field options', error);
        return sortFieldOptions(extraFields);
    }
}
